import {Button, FormControl, Select, styled, TextField} from "@mui/material";

export const CssFormControl = styled(FormControl)({
    '& label': {
        color: 'black',
    },
    '& label.Mui-focused': {
        color: '#a3ce4d',
    },
    '& input': {
        color: 'black',
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: 'black',
        },
        '&:hover fieldset': {
            borderColor: 'black',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#a3ce4d',
        },
    }
});

export const CssSelect = styled(Select)({
    '& .MuiInputLabel-root.Mui-focused': {
        color: '#a3ce4d',
    },
    '& .MuiSelect-select': {
        color: 'black',
    },
    '& .MuiSvgIcon-root ': {
        fill:"black",
    }
});

export const CssButton = styled(Button)({
    width: '40vh',
    fontSize:'3vh',
    color: '#a3ce4d', // Text color
    border: '1px solid',
    borderRadius:'20px',
    borderColor:'#a3ce4d',
    backgroundColor: 'transparent', // Default background color
    // border: '1px solid white', // Default border color
    '&:hover': {
        // backgroundColor: 'white',
        color: '#a3ce4d', // Text color on hover
        borderColor: '#a3ce4d', // Border color on hover
    },
    '&.Mui-focused': {
        backgroundColor: 'transparent', // Background color when focused
        color: '#a3ce4d', // Text color when focused
        borderColor: '#a3ce4d', // Border color when focused
    },
    '&:active': {
        boxShadow: 'none', // Removes the box shadow on click
        backgroundColor: 'transparent', // Background color when active
        borderColor: '#a3ce4d', // Border color when active
    },
    '&.Mui-disabled': {
        opacity: 0.5, // Adds transparency to the disabled state
        color: 'black', // Keeps text color for disabled state
        borderColor: 'grey', // Keeps border color for disabled state
    },
});